import script from "./ship_receive_btn.vue?vue&type=script&setup=true&lang=js"
export * from "./ship_receive_btn.vue?vue&type=script&setup=true&lang=js"

import "./ship_receive_btn.vue?vue&type=style&index=0&id=77840bba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77840bba"]])

export default __exports__